import { JsonPipe, NgTemplateOutlet } from '@angular/common';
import {
  AfterContentInit,
  Component,
  ContentChildren,
  EventEmitter,
  Output,
  QueryList,
  TemplateRef,
  input,
  model,
} from '@angular/core';
import { PanelModule } from 'primeng/panel';
import { PfxTemplateDirective } from '../../../directive/pfx-template/pfx-template.directive';
import { DetailedPanelComponent } from '../detailed-panel/detailed-panel.component';
import { PanelTemplateType, getPanelTemplatesMap } from '../panel';
import { PanelGroupItem } from './types/panel-group-item.type';

@Component({
  selector: 'pfx-panel-group',
  imports: [PanelModule, DetailedPanelComponent, PfxTemplateDirective, JsonPipe, NgTemplateOutlet],
  templateUrl: './panel-group.component.html',
  styleUrl: './panel-group.component.scss',
})
export class PanelGroupComponent implements AfterContentInit {
  public items = input.required<PanelGroupItem[]>();

  public selectedPanelId = model<string | undefined>();

  public clickable = input(false);

  @Output() public readonly panelClicked = new EventEmitter<PanelGroupItem>();

  @ContentChildren(PfxTemplateDirective) protected templates!: QueryList<PfxTemplateDirective>;

  protected PanelTemplateType = PanelTemplateType;

  private panelTemplatesMap = new Map<PanelTemplateType, TemplateRef<unknown>>();

  public ngAfterContentInit(): void {
    this.setPanelTemplates();
  }

  protected handleOnPanelClicked(event: PanelGroupItem): void {
    if (!this.clickable()) {
      return;
    }

    this.panelClicked.emit(event);
  }

  protected getPanelTemplate(type: PanelTemplateType): TemplateRef<unknown> | undefined {
    return this.panelTemplatesMap.get(type);
  }

  private setPanelTemplates(): void {
    this.panelTemplatesMap = getPanelTemplatesMap(this.templates);
  }
}
